<ion-content color="light" [scrollX]="scrollX" [scrollY]="scrollY">
  <red-inner-content [scrollX]="scrollX" [paddingBottom]="paddingBottom">
    <ng-content></ng-content>
  </red-inner-content>
</ion-content>
